import { GreyStarIcon, YellowStarIcon } from '@/components/base/Icons/StarIconPack';
import styles from './Stars.module.scss';

const DEFAULT_STAR_COUNT = 5;

export const starsTestIds = {
  yellowStar: 'yellow-star',
  greyStar: 'grey-star',
};

type StarsProps = { value: number; maxStars?: number };

const Stars = ({ value, maxStars = DEFAULT_STAR_COUNT }: StarsProps) => {
  const activeStars = Math.min(value, maxStars);
  const yellowStars = Array.from({ length: activeStars }, (_, i) => i);
  const greyStars = Array.from({ length: maxStars - activeStars }, (_, i) => i);

  return (
    <div className={styles.starsWrapper}>
      {yellowStars.map((_, i) => (
        <YellowStarIcon key={`yellow-${i}`} data-testid={starsTestIds.yellowStar} />
      ))}
      {greyStars.map((_, i) => (
        <GreyStarIcon key={`grey-${i}`} data-testid={starsTestIds.greyStar} />
      ))}
    </div>
  );
};

export default Stars;
